// 部门人员参照
/* global $ u */
import Collection from 'common/vo/collection'
/* eslint-disable no-unused-vars */
import {Post} from 'common'

function init () {
  // 树形控件加载有误,所以需要每次都重新加载
  let collection = Collection.create('collection.person')
  let vm = {
    config: {
      'id': 'gridperson',
      'data': collection,
      'type': 'grid',
      'multiSelect': false,
      'editable': false,
      pagination: true,
      fields: [{
        'field': 'personname',
        'dataType': 'String',
        'title': '人员',
        'width': '50%'
      }, {
        'field': 'personcode',
        'dataType': 'String',
        'title': '编码',
        'width': '50%'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#personrefer')[0])
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/master-table/index.js